import { IServiceRegistration } from '../../../shared/model/service-registration.model';
import { IServiceRegistrationSearchFilter } from '../../../shared/model/service-registration-search-filter.model';
import { IOpportunity } from "../../../shared/model/opportunity.model";

export interface ServiceRegistrationsState {
  registrations: IServiceRegistration[];
  opportunities: IOpportunity[];
  totalRecordCount: number;
  loading: boolean;
  error: string | null;
  searchFilter: IServiceRegistrationSearchFilter | null;
}

export const initialServiceRegistrationsState: ServiceRegistrationsState = {
  registrations: [],
  opportunities: [],
  totalRecordCount: 0,
  loading: false,
  error: null,
  searchFilter: null
};
